<template>
  <div>
    <b-tabs content-class="mt-3" lazy>
      <b-tab id="loss" class="loss" :title="$t('perdas')">
        <TableVue 
          :modelList="lossList"
          @modelChanged="lossList=$event"
          @deleteModel="deleteLoss($event)"
        />
        <b-icon
          id="btn-icon-add-loss"
          class="btn-iconAdd"
          :title="$t('adicionar-nova-linha')"
          icon="plus-circle-fill"
          @click="addLoss()"
          aria-hidden="true"
        />
      </b-tab>

      <b-tab id="indicators" :title="$t('indicadores')">
        <TableVue 
          :modelList="indicatorList"
          @modelChanged="indicatorList=$event"
          @deleteModel="deleteIndicator($event)"
        />
        <b-icon
          id="btn-icon-add-indicators"
          class="btn-iconAdd"
          :title="$t('adicionar-nova-linha')"
          icon="plus-circle-fill"
          @click="addIndicator()"
          aria-hidden="true"
        />
      </b-tab>

      <b-tab id="effective-production" :title="$t('producao-efetiva')">
        <TableVue 
          :modelList="kpiList"
          @modelChanged="kpiList=$event"
          @deleteModel="deleteKpi($event)"
          :isKPI="true"
        />
        <b-icon
          id="btn-icon-add-effective-production"
          class="btn-iconAdd"
          :title="$t('adicionar-nova-linha')"
          icon="plus-circle-fill"
          @click="addKPI()"
          aria-hidden="true"
        />
      </b-tab>
      <b-tab id="graphic" :title="$t('grafico')">
        <TableVue 
          :modelList="chartList"
          @modelChanged="chartList=$event"
          @deleteModel="deleteChart($event)"
        />
        <b-icon
          id="btn-icon-add-graphic"
          class="btn-iconAdd"
          :title="$t('adicionar-nova-linha')"
          icon="plus-circle-fill"
          @click="addChart()"
          aria-hidden="true"
        />
      </b-tab>
    </b-tabs>
    <hr>
    <b-row class="groupBtn">
      <img
        class="float-right"
        src="@/assets/salvar.png"
        style="margin-left: 30px;"
        :title="$t('salvar-configuracoes')"
        :alt="$t('salvar-configuracoes')"
        @click="save"
      />
      <img
        class="float-right"
        src="@/assets/sair.png"
        style="margin-left: 30px;"
        :title="$t('sair')"
        :alt="$t('sair')"
        @click="cancel"
      />
    </b-row>

  </div>
</template>

<script>
import { KPI, Mapping } from "./tools/InitialKpisCollection";
import { urlMainAPI, defaultSuccess } from "@/global";
import TableVue from "./template/table.vue";
import axios from "axios";

  export default {
    name:"ConfigLossAndEfficiency",
    props: ['lossList', 'indicatorList', 'kpiList', 'chartList', 'updateChartCount'],
    components: { TableVue },
    data() {
      return {
        closeClikEvent: this.updateChartCount,
      }
    },

    watch:{
    },

    methods: {
      async save(){
        defaultSuccess(this.$t('salvando-dados'))
        let setKpiMappgin = []
        for(let i in this.kpiList){
          let [simulation, real] = [...this.kpiList[i].getMappings()]
          setKpiMappgin.push(simulation);
          setKpiMappgin.push(real);
        }

        let mappings = [
          ...this.chartList,
          ...this.lossList, 
          ...this.indicatorList, 
          ...setKpiMappgin
        ]

        const url = `${urlMainAPI}/savemapping`;
        await axios
          .post(url, mappings)
          .then((res) => {
            defaultSuccess(res.data)
        }).catch();

        this.$emit("updateForm", ++this.closeClikEvent);
        this.cancel()
      },

      async deleteLoss(index){
        if(await this.delete(this.lossList[index])){
          this.lossList.splice(index, 1);
        }
      },

      async deleteIndicator(index){
        if(await this.delete(this.indicatorList[index])){
          this.indicatorList.splice(index, 1);
        }
      },
      
      async deleteChart(index){
        if(await this.delete(this.chartList[index])){
          this.chartList.splice(index, 1);
        }
      },

      async deleteKpi(index){
        let [ maps, mapr ] = [...this.kpiList[index].getMappings()]
        if(await this.delete(maps) && await this.delete(mapr)){
          this.kpiList.splice(index, 1);
        }
      },

      async delete(model){
        let success = false
        const url = `${urlMainAPI}/deletemapping`;
        await axios
          .post(url, model)
          .then((res) => {
            success = true;
            defaultSuccess(res.data)
        }).catch();

        return success
      },

      cancel(){
        this.$bvModal.hide("ConfigLossAndEfficiency");    
      },

      addLoss(){
        this.lossList.push(new Mapping())
      },

      addIndicator(){
        this.indicatorList.push(new Mapping({operation: 'papind'}))
      },

      addKPI(){
        this.kpiList.push(new KPI())
      },

      addChart(){
        this.chartList.push(new Mapping({operation: 'papcht'}))
      },
    },

    beforeDestroy(){
      this.$emit("updateChart", ++this.closeClikEvent);
    }
  }
</script>

<style scoped>

.btn-iconAdd {
  font-size: 25px;
  cursor: pointer;
  margin-left: calc(50% - 12.5px);
  margin-top: 8px;
}

.groupBtn {
  display: flex;
  justify-content: flex-end;
  margin-right: 5px;
}

</style>